module.exports = __webpack_public_path__ + "static/media/logo.0072daf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 19
// module chunks = 0